import React from 'react';

import { CloseOutlined } from '@mui/icons-material';
import { Chip } from '@mui/material';

type Props = {
  label: string;
  onDelete: () => void;
};

export default function BaseFilterChip({ label, onDelete }: Props) {
  return <Chip {...{ label, onDelete }} size="small" deleteIcon={<CloseOutlined />} />;
}
